"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _callIfFunc = _interopRequireDefault(require("../call-if-func"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Hook for hovering, with optional `onMouseOut` and `onMouseOver` callbacks
 * @param {Function} [onMouseOut] Additionally called with event when `handleMouseOut` is invoked
 * @param {Function} [onMouseOver] Additionally called with event when `handleMouseOver` is invoked
 * @returns {[boolean, handleMouseOut, handleMouseOver]} [boolean, `handleMouseOut`, `handleMouseOver`]
 */
var useHover = function useHover(initialValue, onMouseOut, onMouseOver) {
  if (initialValue === void 0) {
    initialValue = false;
  }

  var _useState = (0, _react.useState)(initialValue),
      isMouseOver = _useState[0],
      setMouseOver = _useState[1];

  var handleMouseOut = (0, _react.useCallback)(function () {
    for (var _len = arguments.length, event = new Array(_len), _key = 0; _key < _len; _key++) {
      event[_key] = arguments[_key];
    }

    _callIfFunc["default"].apply(void 0, [onMouseOut].concat(event));

    setMouseOver(false);
  }, [onMouseOut]);
  var handleMouseOver = (0, _react.useCallback)(function () {
    for (var _len2 = arguments.length, event = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      event[_key2] = arguments[_key2];
    }

    _callIfFunc["default"].apply(void 0, [onMouseOver].concat(event));

    setMouseOver(true);
  }, [onMouseOver]);
  return [isMouseOver, handleMouseOut, handleMouseOver];
};

var _default = useHover;
exports["default"] = _default;